































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { BankaHesapTuru, BankaHesapTuruLabel } from "@/enum/BankaHesapTuru";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import TextField from "@/components/inputs/TextField.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import { store } from "@/store";
import Select61 from "@/components/inputs/Select61.vue";
import Number from "@/components/inputs/Number.vue";
import UyapBirimAktarim from "@/components/icraproWeb/UyapBirimAktarim.vue";
import EksikIcraDaireleri from "@/components/icraproWeb/EksikIcraDaireleri.vue";
import KapatilanDaireler from "@/components/icraproWeb/KapatilanDaireler.vue";

/**
 * TDT-3397: alanlar `!:` yerine BASLANGIC DEGERIYLE tanimli. Bu kozmetik
 * degil: `!:` alan calisma zamaninda hic var olmuyor, yani `new IcraDairesi()`
 * fiilen bos nesne uretiyordu. Vue 2 bir nesneyi tepkisel yaparken yalniz O AN
 * VAR OLAN ozellikleri sarar; sonradan atanan alan tepkisel olmaz. Sonuc:
 * kullanici forma yazdikca hicbir hesaplanan deger yeniden hesaplanmiyor,
 * dolayisiyla "neden gonderemiyorum" uyarisi da guncellenemiyordu.
 */
class IcraDairesi {
  id: number | null = null;
  isim = '';
  vergi_no = '';
  aktif_mi = false;
  sehir_id: number | null = null;
  ilce_id: number | null = null;
  banka_hesabi_id: number | null = null;
  banka_hesabi: BankaHesabi = new BankaHesabi();
}

class BankaHesabi {
  id: number | null = null;
  isim = '';
  banka_id: number | null = null;
  para_birimi_id: number | null = null;
  sube_adi = '';
  hesap_numarasi = '';
  iban = '';
  // Bilerek BOS: on secim yapilirsa IBAN alani aciliyor ve zorunlu hale
  // geliyordu; oysa daire banka hesabi olmadan da kaydedilebilir.
  hesap_tipi: 'iban' | 'hesap_no' | null = null;
}

class Mahkeme {
  id!: number;
  isim!: string;
  kod!: string;
  mahkeme_tur!: 'adliye' | 'idari';
  aktif_mi!: boolean;
  adliye_id!: number;
  yargi_birimi_id!: number;
  sehir_id!: number;
}

@Component({
  components: { Number, Select61, Id, EForm, TextField, DeleteButton, UyapBirimAktarim, EksikIcraDaireleri, KapatilanDaireler },
  computed: {
    store() {
      return store;
    },
    BankaHesapTuru: () => BankaHesapTuru,
    BankaHesapTuruLabel: () => BankaHesapTuruLabel,
  }
})
export default class IcraDairesiMahkeme extends Vue {
  sekme: number = 0;
  secilenDaireler: any[] = [];
  durumIsleniyor: boolean = false;

  icraDairesiDialog: boolean = false;
  icraDairesiAction: string = this.$store.state.icwApiUrl + 'admin/icra-dairesi';
  icraDairesiData = new IcraDairesi();
  icraDairesiTitle: string = "";
  icraDaireleriLoading: boolean = true;
  icraDaireleriHeaders = [
    { text: "Id", value: "id" },
    { text: "İsim", value: "isim" },
    // UYAP birim kimligi: aktarimin doldurdugu alan. Bos olan kayit takip
    // acilisinda otomatik eslesemiyor, elle araniyor -- operatorun hangi
    // dairelerin hala eksik oldugunu gorebilmesi gerekiyor.
    { text: "UYAP Birim No", value: "uyap_birim_id", width: 130 },
    { text: "Vergi No", value: "vergi_no" },
    { text: "Şehir", value: "sehir.isim" },
    { text: "İlçe", value: "ilce.isim" },
    { text: "Banka Hesabı Adı", value: "banka_hesabi.isim" },
    { text: "Banka Hesap Türü", value: "banka_hesabi.hesap_tipi" },
    { text: "IBAN/Hesap No", value: "iban_hesap_no" },
    { text: "Durum", value: "aktif_mi" },
    { text: "İşlemler", value: "actions" }
  ];
  icraDaireleri = [];
  icraDairesiSearch: string = "";

  mahkemeDialog: boolean = false;
  mahkemeAction: string = this.$store.state.icwApiUrl + 'admin/mahkeme';
  mahkemeData = new Mahkeme();
  mahkemeTitle: string = "";
  mahkemelerLoading: boolean = true;
  mahkemelerHeaders = [
    { text: "Id", value: "id" },
    { text: "Mahkeme Adı", value: "isim" },
    { text: "Kod", value: "kod" },
    { text: "Tur", value: "mahkeme_tur" },
    { text: "Adliye", value: "adliye.isim" },
    { text: "Yargı Birimi", value: "yargi_birimi.isim" },
    { text: "Şehir", value: "sehir.isim" },
    { text: "İşlemler", value: "actions" }
  ];
  mahkemeler = [];
  mahkemeSearch = "";

  created() {
    this.loadIcraDaireleri();
    this.loadMahkemeler();
  }

  /**
   * UYAP aktarımıyla açılan pasif kayıtlarda banka hesabı henüz yok;
   * hücre boş görünmeli, hata vermemeli.
   */
  ibanVeyaHesapNo(item: IcraDairesi): string {
    const hesap: any = item.banka_hesabi;
    if (!hesap) return "";
    return (hesap.hesap_tipi == BankaHesapTuru.iban ? hesap.iban : hesap.hesap_numarasi) || "";
  }

  /** Aktarım kapatma da yapmış olabilir; her iki liste de tazelenir. */
  aktarimSonrasi() {
    this.loadIcraDaireleri();
    const kapatilanlar: any = this.$refs.kapatilanlar;
    if (kapatilanlar && typeof kapatilanlar.yukle === 'function') {
      kapatilanlar.yukle();
    }
  }

  /**
   * Düz alfabetik sıra -- durum sıraya karışmaz.
   *
   * ⚠ Bir önceki halinde pasifler ve kapatılmışlar listenin sonuna itiliyordu.
   * KALDIRILDI (TDT-3397 geri dönüşü): panelde 1160 kayıt var; sona itilen bir
   * kayıt pratikte bulunamıyordu ve test eden kişi "pasife alınanları bir daha
   * bulamıyorum" diye bildirdi. Kayıtlar hiçbir zaman gizlenmiyordu, sadece
   * ulaşılamaz hale geliyordu. Durum bilgisini DURUM sütunundaki çip taşıyor;
   * operatör o sütuna basarak pasifleri gruplayabilir.
   */
  get siraliIcraDaireleri(): any[] {
    return this.icraDaireleri.slice().sort((a: any, b: any) =>
        String(a.isim || "").localeCompare(String(b.isim || ""), "tr"));
  }

  /**
   * Türkçe harf sırasıyla sıralar; durum bilgisine BAKMAZ.
   * Vuetify'ın kendi sıralaması Türkçe harfleri (I/İ, G/Ğ, S/Ş) doğru
   * sıralamadığı için tabloya bağlandı -- tek işi bu.
   */
  turkceSirala(items: any[], sortBy: string[], sortDesc: boolean[], locale: string): any[] {
    const kopya = items.slice();

    kopya.sort((a: any, b: any) => {
      for (let i = 0; i < sortBy.length; i++) {
        const av = this.alanDegeri(a, sortBy[i]);
        const bv = this.alanDegeri(b, sortBy[i]);
        let fark = String(av).localeCompare(String(bv), locale || "tr", { numeric: true });
        if (sortDesc[i]) fark = -fark;
        if (fark !== 0) return fark;
      }

      return String(a.isim || "").localeCompare(String(b.isim || ""), "tr", { numeric: true });
    });

    return kopya;
  }

  /** "sehir.isim" gibi noktalı yolları çözer. */
  alanDegeri(nesne: any, yol: string): any {
    return yol.split(".").reduce((o: any, k: string) => (o == null ? o : o[k]), nesne) ?? "";
  }

  /**
   * TDT-3397: islem sonucu GORUNUR olmak zorunda. Onceki halinde hata
   * `console.log`'a yaziliyordu; istek dusse de, sunucu "kayit zaten istenen
   * durumda" dese de ekranda hicbir sey degismiyordu ve test eden kisi
   * "herhangi bir islem yaptigimizda degisen bir sey olmuyor" diye bildirdi.
   * Iki farkli sebep ayni sessizlige cikiyordu.
   *
   * Artik uc durum da ayri ayri soyleniyor: kac kayit guncellendi, kac kayit
   * zaten istenen durumdaydi, istek dustuyse sunucunun durum koduyla hata.
   *
   * ⚠ Bu dosyada `Number` bir BILESEN olarak import ediliyor; global
   * `Number()` golgelenmis durumda ve cagrilamaz. Sayiya cevirme bu yuzden
   * yerel yardimciyla yapiliyor.
   */
  async durumDegistir(degisiklik: any) {
    if (!this.secilenDaireler.length) return;
    this.durumIsleniyor = true;
    const toplam = this.secilenDaireler.length;
    const sayiya = (v: any): number => parseInt(String(v ?? 0), 10) || 0;
    try {
      const yanit = await this.$http.post(
          this.$store.state.icwApiUrl + 'admin/icra-daireleri/durum',
          { data: { ids: this.secilenDaireler.map((r: any) => r.id), ...degisiklik }, sendJson: true }
      );

      const ozet = (yanit && yanit.data && yanit.data.ozet) || {};
      const guncellendi = sayiya(ozet.guncellendi);
      const atlandi = sayiya(ozet.atlandi);
      const hata = sayiya(ozet.hata);

      if (guncellendi > 0) {
        let mesaj = `${guncellendi} kayıt güncellendi`;
        if (atlandi > 0) mesaj += `, ${atlandi} kayıt zaten istenen durumdaydı`;
        if (hata > 0) mesaj += `, ${hata} kayıt güncellenemedi`;
        this.$toast.success(mesaj + '.');
      } else if (hata > 0) {
        this.$toast.error(`${hata} kayıt güncellenemedi.`);
      } else {
        // Sunucu isledi ama degisen kayit yok: secilenlerin hepsi zaten istenen
        // durumdaydi. Sessiz kalmak "buton calismiyor" izlenimi veriyordu.
        this.$toast.info(`Değişiklik yok — seçilen ${toplam} kayıt zaten istenen durumda.`);
      }

      this.secilenDaireler = [];
      await this.loadIcraDaireleri();
      const kapatilanlar: any = this.$refs.kapatilanlar;
      if (kapatilanlar && typeof kapatilanlar.yukle === 'function') kapatilanlar.yukle();
    } catch (e) {
      const hataDetayi: any = e;
      const durum = hataDetayi && hataDetayi.response ? hataDetayi.response.status : null;
      this.$toast.error(`Durum değiştirilemedi${durum ? ` (sunucu ${durum} döndü)` : ''}.`);
      console.error('admin/icra-daireleri/durum başarısız:', e);
    } finally {
      this.durumIsleniyor = false;
    }
  }

  async loadIcraDaireleri() {
    try {
      this.icraDaireleriLoading = true;
      this.icraDaireleri = (await this.$http.get(this.$store.state.icwApiUrl + 'admin/icra-daireleri')).data;
    } catch (e) {
      console.log('Hata:', e);
    } finally {
      this.icraDaireleriLoading = false;
    }
  }

  handleIcraDairesiSuccess(response: any) {
    // Form başarıyla gönderildikten sonra diyalogu kapatıyoruz.
    this.icraDairesiDialog = false;
    // Tabloyu yeniliyoruz.
    this.loadIcraDaireleri();
  }

  /**
   * TDT-3397: pencere listedeki satirin KOPYASI ile acilir, kendisiyle degil.
   *
   * Onceden `icraDairesiData = item` deniyordu; bu, tablodaki canli nesneyi
   * dogrudan baglar. Penceredeki her degisiklik listeyi aninda degistiriyor,
   * carpiyla kapatmak geri almiyordu. Test eden kisi bunu "durumu pasif yapip
   * kapattim, daire hicbir yerde gorunmuyor; sayfayi yenileyince geri geldi ve
   * aktifti" diye bildirdi: kayit pasife dustugu icin siralamada en alta
   * gidiyor, sunucuya hic yazilmadigi icin yenilemede eski haline donuyordu.
   * Referans hatasi eskiden de vardi; aktif/pasif anahtari eklenene kadar
   * gorunur bir zarari yoktu.
   */
  editIcraDairesi(item: IcraDairesi) {
    this.icraDairesiTitle = "Düzenle";
    this.icraDairesiData = this.duzenlemeKopyasi(item);
    this.icraDairesiAction = this.$store.state.icwApiUrl + 'admin/icra-dairesi/' + item.id;
    this.icraDairesiDialog = true;
  }

  /**
   * Satirin duzenlenebilir kopyasi.
   *
   * ⚠ Banka hesabi OLMAYAN kayitlar: UYAP aktarimiyla acilan daireler hesapsiz
   * geliyor ve API `banka_hesabi: null` donduruyor. Form `banka_hesabi.isim`'e
   * korumasiz baglandigi icin pencere bu kayitlarda aciliyordu ama hata
   * veriyordu.
   *
   * ⚠ Varsayilanlar TEK TEK yaziliyor, `new BankaHesabi()` ile degil: o sinifin
   * alanlari `!:` ile tanimli ve baslangic degeri yok, yani ornek calisma
   * zamaninda BOS nesne. Vue 2'de sonradan eklenen ozellik tepkisel olmadigi
   * icin alanlarin bastan var olmasi gerekiyor.
   */
  /**
   * Banka hesabina DOKUNULDU mu? API'deki `required_with` tetikleyici listesinin
   * birebir aynisi: bu alanlardan biri doluysa para birimi de zorunlu olur.
   * Liste iki tarafta ayni kalmali; ayrisirsa ekran "gonderilebilir" der, API
   * 422 dondurur.
   */
  get bankaHesabinaDokunuldu(): boolean {
    const hesap: any = this.icraDairesiData.banka_hesabi || {};
    return ['isim', 'banka_id', 'sube_adi', 'iban', 'hesap_numarasi']
        .some((alan) => String(hesap[alan] ?? '').trim() !== '');
  }

  /**
   * Hesap tipi, yukaridaki alanlara EK OLARAK para biriminden de tetiklenir
   * (API kurali boyle: `required_with:...,banka_hesabi.para_birimi_id`).
   */
  get bankaHesabiTipZorunlu(): boolean {
    const hesap: any = this.icraDairesiData.banka_hesabi || {};
    return this.bankaHesabinaDokunuldu || String(hesap.para_birimi_id ?? '').trim() !== '';
  }

  /**
   * TDT-3397: "Gonder" dugmesi form gecersizken kapaniyor ama Vuetify hata
   * mesajlarini alana DOKUNULANA kadar gostermiyor. Bos bir formda sonuc:
   * kapali dugme + tek satir aciklama yok. Bu ozet dugmenin hemen yaninda
   * neyin eksik oldugunu soyluyor.
   */
  get eksikAlanlar(): string[] {
    const eksik: string[] = [];
    const veri: any = this.icraDairesiData;
    const hesap: any = veri.banka_hesabi || {};

    if (String(veri.isim ?? '').trim() === '') eksik.push('İsim');
    if (!veri.sehir_id) eksik.push('Şehir');
    if (this.bankaHesabinaDokunuldu && !hesap.para_birimi_id) eksik.push('Para Birimi');
    if (this.bankaHesabiTipZorunlu && !hesap.hesap_tipi) eksik.push('Hesap Tipi');
    // Bu ikisi ZORUNLU degil (API'de nullable). Yalniz DOLU ama gecersizken
    // bildirilir -- yoksa "Gonder" bicim kurali yuzunden kapali kalir ve
    // gerekcesi yine gorunmez olur.
    const ibanHane = this.ibanHanesi;
    if (hesap.hesap_tipi === 'iban' && ibanHane !== '' && !/^[0-9]{24}$/.test(ibanHane)) {
      eksik.push('IBAN 24 hane olmalı');
    }
    const hesapNo = String(hesap.hesap_numarasi ?? '').trim();
    if (hesap.hesap_tipi === 'hesap_no' && hesapNo !== '' && !/^[0-9]{12}$/.test(hesapNo)) {
      eksik.push('Hesap numarası 12 hane olmalı');
    }
    return eksik;
  }

  /**
   * IBAN'in TR'siz hali. Saklanan deger ("TR" + 24 hane) ile `number`
   * bileseninin bekledigi bicim (24 hane) arasinda cevrim yapar; boylece
   * icraDairesiData her zaman veritabanindaki kanonik degeri tasir ve
   * gonderim yolunda (EForm) hicbir degisiklik gerekmez.
   */
  get ibanHanesi(): string {
    const deger = (this.icraDairesiData.banka_hesabi.iban || '') as string;
    return deger.replace(/^TR/i, '');
  }

  set ibanHanesi(haneler: string) {
    this.icraDairesiData.banka_hesabi.iban = haneler ? 'TR' + haneler : '';
  }

  private duzenlemeKopyasi(item: IcraDairesi): IcraDairesi {
    const bosHesap = {
      isim: '',
      banka_id: null,
      para_birimi_id: null,
      sube_adi: '',
      hesap_numarasi: '',
      iban: '',
      hesap_tipi: null as ('iban' | 'hesap_no' | null),
    };
    const kopya: any = { ...(item as any) };
    kopya.banka_hesabi = { ...bosHesap, ...((item as any).banka_hesabi || {}) };
    return kopya as IcraDairesi;
  }

  addIcraDairesi() {
    this.icraDairesiTitle = "Ekle";
    this.icraDairesiData = new IcraDairesi();
    this.icraDairesiData.aktif_mi = true;
    this.icraDairesiAction = this.$store.state.icwApiUrl + 'admin/icra-dairesi';
    this.icraDairesiDialog = true;
  }

  async loadMahkemeler() {
    try {
      this.mahkemelerLoading = true;
      this.mahkemeler = (await this.$http.get(this.$store.state.icwApiUrl + 'admin/mahkemeler')).data;
    } catch (e) {
      console.log('Hata:', e);
    } finally {
      this.mahkemelerLoading = false;
    }
  }

  editMahkeme(item: Mahkeme) {
    this.mahkemeTitle = "Düzenle";
    this.mahkemeData = item;
    this.mahkemeAction = this.$store.state.icwApiUrl + 'admin/mahkeme/' + item.id;
    this.mahkemeDialog = true;
  }

  addMahkeme() {
    this.mahkemeTitle = "Ekle";
    this.mahkemeData = new Mahkeme();
    this.mahkemeAction = this.$store.state.icwApiUrl + 'admin/mahkeme';
    this.mahkemeDialog = true;
  }
}
